<app-page-hero
  badge="من نحن"
  title="نبني مستقبل الزراعة"
  highlight="بثقة و خبرة"
  descriptionLine1="شركة رائدة في مجال التعاقد الزراعي، نقدم فرصاً تعاقدية مدروسة"
  descriptionLine2=" ومستدامة"
  bgImage="/images/bg.png">

</app-page-hero>
